import { render } from "./DropdownAutocompleteMultiSelect.vue?vue&type=template&id=2a59d87d&ts=true"
import script from "./DropdownAutocompleteMultiSelect.vue?vue&type=script&lang=ts"
export * from "./DropdownAutocompleteMultiSelect.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__